import type { ErrorDetailResponse, ValidationError } from "@/api/bale.zod";

export type OrvalError = Error & { info: ErrorDetailResponse; status: number };

export function isOrvalError(error: unknown): error is OrvalError {
  return (
    error instanceof Error &&
    "info" in error &&
    !!error.info &&
    typeof error.info === "object" &&
    "code" in error.info &&
    typeof error.info.code === "string"
  );
}

export interface ValidationErrorDetailResponse extends ErrorDetailResponse {
  code: "ValidationError";
  detail: ValidationError;
}

export function isValidationErrorDetail(response: ErrorDetailResponse): response is ValidationErrorDetailResponse {
  return response.code === "ValidationError";
}
